import isEmpty from "lodash/isEmpty"

export default function validateInput(data) {
  const lang_code = localStorage.getItem("lang")

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    ZARMA: {
      message_required: `Tilas batamo hima ga bara`,
    },
    HAOUSSA: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    ar: {
      message_required: `هذا الحقل اجباري`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_digits_only = {
    fr: {
      message_required: `Entrez uniquement des chiffres`,
    },
    en: {
      message_required: `Enter digits only`,
    },
    sw: {
      message_required: `Ingiza tarakimu pekee`,
    },
    ZARMA: {
      message_required: `Hantum  lambayze hinne`,
    },
    HAOUSSA: {
      message_required: `Rubuta ỳan ƙilgo kaɗay`,
    },
    es: {
      message_required: `Inserta solo dígitos`,
    },
    ar: {
      message_required: `ادخال أرقام فقط`,
    },
    pt: {
      message_required: `Insira apenas dígitos`,
    },
  }

  const lang_pin_length = {
    fr: {
      message_required: `Le code PIN doit comporter 4 chiffres`,
    },
    en: {
      message_required: `Pin should be 4 digits`,
    },
    sw: {
      message_required: `PIN mwisho tarakimu 4`,
    },
    ZARMA: {
      message_required: `Zarma for PIN mwisho tarakimu 4`,
    },
    HAOUSSA: {
      message_required: `ỳan ƙilgo hudu kaday ke cikin lamban kanki`,
    },
    es: {
      message_required: `El pin debe tener 4 dígitos`,
    },
    ar: {
      message_required: `الرمز من ٤ أرقام فقط`,
    },
    pt: {
      message_required: `O PIN deve ter 4 dígitos`,
    },
  }

  const lang_pin_mismatch = {
    fr: {
      message_required: `Erreur de code PIN`,
    },
    en: {
      message_required: `Pin does not match`,
    },
    sw: {
      message_required: `PIN haifanani`,
    },
    ZARMA: {
      message_required: `Zarma for Pin does not match`,
    },
    HAOUSSA: {
      message_required: `Lamban ki na kanki ta bambanta`,
    },
    es: {
      message_required: `El pin no coincide`,
    },
    lb: {
      message_required: `Pin does not match`,
    },
    pt: {
      message_required: `O PIN não corresponde`,
    },
    ar: {
      message_required: `الرمز غير مطابق`,
    },
  }

  let errors = {}

  if (data.pin === "") {
    errors.pin = lang_required[lang_code].message_required
  }

  if (data.confirm_pin === "") {
    errors.confirm_pin = lang_required[lang_code].message_required
  }

  if (data.confirm_pin !== data.pin) {
    errors.pin = lang_pin_mismatch[lang_code].message_required
    errors.confirm_pin = lang_pin_mismatch[lang_code].message_required
  }

  if (isNaN(data.pin)) {
    errors.pin = lang_digits_only[lang_code].message_required
  }

  if (isNaN(data.confirm_pin)) {
    errors.confirm_pin = lang_digits_only[lang_code].message_required
  }

  if (data.pin.length !== 4) {
    errors.pin = lang_pin_length[lang_code].message_required
  }

  if (data.confirm_pin.length !== 4) {
    errors.confirm_pin = lang_pin_length[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
